/**
 * Idiomes que l'app sap mostrar. Els actius de cada instància són a settings/global.enabledLocales (§11).
 * Aquest fitxer no importa zod: la part pública l'importa via '@blauturquesa/shared/locales'
 * i no ha de carregar la llibreria sencera. L'esquema zod és a schemas.ts.
 */
export const SUPPORTED_LOCALES = ['ca', 'es', 'en', 'de'];
export const DEFAULT_LOCALE = 'ca';
export function isLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
/**
 * Regla de visualització pública (§11.2): idioma demanat → idioma d'origen del camp.
 * Un text buit compta com a absent.
 */
export function resolveI18nText(value, locale, sourceLocale) {
    const wanted = value?.[locale];
    if (wanted !== undefined && wanted !== '') {
        return { text: wanted, locale, isFallback: false };
    }
    if (sourceLocale !== undefined) {
        const source = value?.[sourceLocale];
        if (source !== undefined && source !== '') {
            return { text: source, locale: sourceLocale, isFallback: true };
        }
    }
    return { text: '', locale: null, isFallback: false };
}
